import { render, staticRenderFns } from "./NxScenarios.vue?vue&type=template&id=966cf054&scoped=true"
import script from "./NxScenarios.vue?vue&type=script&lang=js"
export * from "./NxScenarios.vue?vue&type=script&lang=js"
import style0 from "./NxScenarios.vue?vue&type=style&index=0&id=966cf054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966cf054",
  null
  
)

export default component.exports